import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SimpleTabs, Notes, FilesComponent, Comments } from 'components';
import { FundingSourceServices, FundingSourceSingleGeneral, FundingSourceSingleHeader, BillingSettings } from './core';
import { commentModels, fileEnums, KeyPurpose, noteModels, PermissionList, RolePermission } from 'utils';
import { HistoryTab } from 'fragments';
import { formModelEnums } from 'pages';
import { PayerEnrollments } from './core/payerEnrollments';

export const FundingSourceItem = ({}) => {
    const params = useParams();
    const data = useSelector((state) => state.fundingSource.fundingSourceItem);
    const canUseIntegrations = useSelector((state) => state.system.canUseIntegrations);

    const tabsLabels = [
        RolePermission([PermissionList.FS_READ?.code, PermissionList.FS_CREATE?.code, PermissionList.FS_STATUS?.code]) && {
            label: 'General',
        },
        RolePermission([PermissionList.FS_SERVICE_READ?.code, PermissionList.FS_SERVICE_CREATE?.code]) && { label: 'Services' },
        RolePermission([PermissionList.FS_CREATE?.code]) && { label: 'Billing Settings' },
        canUseIntegrations?.activeTlClearinghouse && { label: 'Enrollments' },
        { label: 'Comments' },
        RolePermission([PermissionList.FS_NOTE_READ?.code, PermissionList.FS_NOTE_MANAGE?.code]) && { label: 'Notes' },
        RolePermission([PermissionList.FS_HISTORY_READ?.code]) && { label: 'History' },
        RolePermission([PermissionList.FS_FILE_READ?.code, PermissionList.FS_FILE_MANAGE?.code]) && { label: 'Files' },
    ];

    const tabsContent = [
        RolePermission([PermissionList.FS_READ?.code, PermissionList.FS_CREATE?.code, PermissionList.FS_STATUS?.code]) && {
            tabComponent: <FundingSourceSingleGeneral data={data} />,
            tab: 'General',
        },
        RolePermission([PermissionList.FS_SERVICE_READ?.code, PermissionList.FS_SERVICE_CREATE?.code]) && {
            tabComponent: <FundingSourceServices />,
            tab: 'Services',
        },
        RolePermission([PermissionList.FS_CREATE?.code]) && {
            tabComponent: <BillingSettings />,
            tab: 'Billing Settings',
        },
        canUseIntegrations?.activeTlClearinghouse && {
            tabComponent: <PayerEnrollments />,
            tab: 'Enrollments',
        },
        {
            tabComponent: (
                <Comments
                    fromDetail={true}
                    resource={commentModels.Funder}
                    resourceId={params?.id}
                    label={'Payer'}
                    width={700}
                    height={600}
                    attachmentPurpose={KeyPurpose.FUNDER_DOC}
                    enableAiImprove
                />
            ),
            tab: 'Comments',
        },
        RolePermission([PermissionList.FS_NOTE_READ?.code, PermissionList.FS_NOTE_MANAGE?.code]) && {
            tabComponent: (
                <Notes
                    id={params?.id}
                    onModel={noteModels.Funder}
                    formModel={formModelEnums.PAYERNOTES}
                    permissions={[PermissionList.FS_NOTE_MANAGE?.code]}
                />
            ),
            tab: 'Notes',
        },
        RolePermission([PermissionList.FS_HISTORY_READ?.code]) && {
            tabComponent: <HistoryTab currentId={params?.id} onModel={'Funder'} />,
            tab: 'History',
        },
        RolePermission([PermissionList.FS_FILE_READ?.code, PermissionList.FS_FILE_MANAGE?.code]) && {
            tabComponent: <FilesComponent onResource={fileEnums.PAYER} permissions={[PermissionList.FS_FILE_MANAGE?.code]} />,
            tab: 'Files',
        },
    ];

    return (
        <>
            <div className="tab-box-wrapper">
                <FundingSourceSingleHeader />
                <SimpleTabs
                    defaultTab={
                        RolePermission([PermissionList.FS_READ?.code, PermissionList.FS_CREATE?.code, PermissionList.FS_STATUS?.code])
                            ? 'General'
                            : ''
                    }
                    tabsLabels={tabsLabels}
                    tabsContent={tabsContent}
                />
            </div>
        </>
    );
};
